export default Object.keys({
  "teal": "#008080",
  "firebrick": "#FF0000",
  "olive": "#989838",
  "purple": "#800080",
  "fuchsia": "#FF00FF",
  "green": "#008000",
  "lime": "#00FF00",
  "yellow": "#FFFF00",
  "aqua": "#00FFFF",
  "deepskyblue": "#00BFFF",
  "darkturquoise": "#00CED1",
  "mediumspringgreen": "#00FA9A",
  "springgreen": "#00FF7F",
  "cyan": "#00FFFF",
  "midnightblue": "#191970",
  "dodgerblue": "#1E90FF",
  "lightseagreen": "#20B2AA",
  "forestgreen": "#228B22",
  "seagreen": "#2E8B57",
  "darkslategray": "#2F4F4F",
  "darkslategrey": "#2F4F4F",
  "limegreen": "#32CD32",
  "mediumseagreen": "#3CB371",
  "turquoise": "#40E0D0",
  "royalblue": "#4169E1",
  "steelblue": "#4682B4",
  "darkslateblue": "#483D8B",
  "mediumturquoise": "#48D1CC",
  "darkolivegreen": "#556B2F",
  "cadetblue": "#5F9EA0",
  "cornflowerblue": "#6495ED",
  "rebeccapurple": "#663399",
  "mediumaquamarine": "#66CDAA",
  "blueviolet": "#8A2BE2",
  "darkred": "#8B0000",
  "darkseagreen": "#8FBC8F",
  "mediumpurple": "#9370DB",
  "darkviolet": "#9400D3",
  "palegreen": "#98FB98",
  "darkorchid": "#9932CC",
  "yellowgreen": "#9ACD32",
  "sienna": "#A0522D",
  "brown": "#A52A2A",
  "darkgray": "#A9A9A9",
  "darkgrey": "#A9A9A9",
  "lightblue": "#ADD8E6",
  "greenyellow": "#ADFF2F",
  "paleturquoise": "#AFEEEE",
  "lightsteelblue": "#B0C4DE",
  "powderblue": "#B0E0E6",
  "firebrick": "#B22222",
  "darkgoldenrod": "#B8860B",
  "mediumorchid": "#BA55D3",
  "rosybrown": "#BC8F8F",
  "darkkhaki": "#BDB76B",
  "mediumvioletred": "#C71585",
  "indianred": "#CD5C5C",
  "peru": "#CD853F",
  "chocolate": "#D2691E",
  "tan": "#D2B48C",
  "lightgray": "#D3D3D3",
  "lightgrey": "#D3D3D3",
  "thistle": "#D8BFD8",
  "orchid": "#DA70D6",
  "goldenrod": "#DAA520",
  "palevioletred": "#DB7093",
  "crimson": "#DC143C",
  "gainsboro": "#DCDCDC",
  "plum": "#DDA0DD",
  "burlywood": "#DEB887",
  "lightcyan": "#E0FFFF",
  "lavender": "#E6E6FA",
  "darksalmon": "#E9967A",
  "violet": "#EE82EE",
  "palegoldenrod": "#EEE8AA",
  "lightcoral": "#F08080",
  "khaki": "#F0E68C",
  "aliceblue": "#F0F8FF",
  "honeydew": "#F0FFF0",
  "azure": "#F0FFFF",
  "sandybrown": "#F4A460",
  "wheat": "#F5DEB3",
  "beige": "#F5F5DC",
  "whitesmoke": "#F5F5F5",
  "mintcream": "#F5FFFA",
  "ghostwhite": "#F8F8FF",
  "salmon": "#FA8072",
  "antiquewhite": "#FAEBD7",
  "linen": "#FAF0E6",
  "lightgoldenrodyellow": "#FAFAD2",
  "oldlace": "#FDF5E6",
  "magenta": "#FF00FF",
  "deeppink": "#FF1493",
  "orangered": "#FF4500",
  "tomato": "#FF6347",
  "hotpink": "#FF69B4",
  "coral": "#FF7F50",
  "darkorange": "#FF8C00",
  "lightsalmon": "#FFA07A",
  "orange": "#FFA500",
  "lightpink": "#FFB6C1",
  "pink": "#FFC0CB",
  "gold": "#FFD700",
  "peachpuff": "#FFDAB9",
  "navajowhite": "#FFDEAD",
  "moccasin": "#FFE4B5",
  "bisque": "#FFE4C4",
  "mistyrose": "#FFE4E1",
  "blanchedalmond": "#FFEBCD",
  "papayawhip": "#FFEFD5",
  "lavenderblush": "#FFF0F5",
  "seashell": "#FFF5EE",
  "cornsilk": "#FFF8DC",
  "lemonchiffon": "#FFFACD",
  "floralwhite": "#FFFAF0",
  "snow": "#FFFAFA",
  "lightyellow": "#FFFFE0",
  "ivory": "#FFFFF0"
});

// List of 50 background colors with contrast compliant textColor colors
export const backgroundColors = {
  clay: {
    background: 'linear-gradient(to right, #f5f5dc, #e6e6c3)',
    textColor: 'black'
  },
  orange: {
    background: 'linear-gradient(to right, #ff9800, #f57c00)',
    textColor: 'white'
  },
  green: {
    background: 'linear-gradient(to right, #4caf50, #8bc34a)',
    textColor: 'white'
  },
  gray: {
    background: 'linear-gradient(to right, #9e9e9e, #616161)',
    textColor: 'white'
  },
  blue: {
    background: 'linear-gradient(to right, #2196f3, #00bcd4)',
    textColor: 'white'
  },
  purple: {
    background: 'linear-gradient(to right, #673ab7, #512da8)',
    textColor: 'white'
  },
  pink: {
    background: 'linear-gradient(to right, #e91e63, #d81b60)',
    textColor: 'white'
  },
  red: {
    background: 'linear-gradient(to right, #f44336, #e53935)',
    textColor: 'white'
  },
  yellow: {
    background: 'linear-gradient(to right, #ffeb3b, #fbc02d)',
    textColor: 'black'
  },
  teal: {
    background: 'linear-gradient(to right, #00bcd4, #0097a7)',
    textColor: 'white'
  },
  brown: {
    background: 'linear-gradient(to right, #795548, #5d4037)',
    textColor: 'white'
  },
  honeydew: {
    background: 'linear-gradient(to right, #e0f2f1, #c8e6c9)',
    textColor: 'black'
  },
  indigo: {
    background: 'linear-gradient(to right, #3f51b5, #303f9f)',
    textColor: 'white'
  },
  chartreuse: {
    background: 'linear-gradient(to right, #7cb342, #689f38)',
    textColor: 'white'
  },
  'blood orange': {
    background: 'linear-gradient(to right, #ff5722, #ff5252)',
    textColor: 'white'
  },
  gold: {
    background: 'linear-gradient(to right, #ffd600, #ffc107)',
    textColor: 'black'
  },
  bronze: {
    background: 'linear-gradient(to right, #bdbdbd, #8c8c8c)',
    textColor: 'white'
  },
  sienna: {
    background: 'linear-gradient(to right, #f57c00, #e65100)',
    textColor: 'white'
  },
  coral: {
    background: 'linear-gradient(to right, #ff4081, #f50057)',
    textColor: 'white'
  },
  khaki: {
    background: 'linear-gradient(to right, #f0e68c, #b2df8a)',
    textColor: 'black'
  },
  mauve: {
    background: 'linear-gradient(to right, #e0f2f1, #b39ddb)',
    textColor: 'black'
  },
  'spring blue': {
    background: 'linear-gradient(to right, #00bcd4, #0097a7)',
    textColor: 'white'
  },
  'spring green': {
    background: 'linear-gradient(to right, #00ff7f, #00ee76)',
    textColor: 'white'
  },
  'dodger blue': {
    background: 'linear-gradient(to right, #1e88e5, #00bcd4)',
    textColor: 'white'
  },
  'cadet blue': {
    background: 'linear-gradient(to right, #5e35b1, #512da8)',
    textColor: 'white'
  },
  'pale turquoise': {
    background: 'linear-gradient(to right, #e0f2f1, #b2df8a)',
    textColor: 'black'
  },
  butter: {
    background: 'linear-gradient(to right, #f0c100, #f0e100)',
    textColor: 'black'
  },
  linen: {
    background: 'linear-gradient(to right, #faf0e6, #fdf5e6)',
    textColor: 'black'
  },
  'lemon chiffon': {
    background: 'linear-gradient(to right, #fffacd, #fff8dc)',
    textColor: 'black'  
  }
};